import { FunctionComponent } from 'react';
import PageSidebar from 'components/PageSidebar';
import PrivatePage from './PrivatePage';
import BoardingComponent from 'components/Boarding/BoardingComponent';
import { useServiceCategoryAccess } from 'hooks';
import { Redirect } from 'react-router-dom';
import { useFilteredServicesNavigation } from 'utils/PageSidebarUtils';

interface ServicesProps {
    create: string;
}

export const Boarding: FunctionComponent<ServicesProps> = props => {
    const { isAllowed, redirectTo } = useServiceCategoryAccess('boarding');
    const { selectedKey, setSelectedKey, sidebarItems } = useFilteredServicesNavigation('boarding');

    if (!isAllowed) {
        return <Redirect to={redirectTo} />;
    }

    const sidebar = (
        <PageSidebar
            title="Services"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    return (
        <PrivatePage
            title="Boarding - Cuddles"
            pageName="/boarding"
            pageSidebar={sidebar}
        >
            <BoardingComponent />
        </PrivatePage>
    );
};

export default Boarding;
